export const getConditionId = (conditionId: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { type, id }: any = JSON.parse(conditionId);

  return JSON.stringify({ id, type });
};
